import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const evIChargeSignup: IMcAppType = {
  name: "evIChargeSignup",
  path: "/my/service/ev-icharge/signup",
  description: "Power Up - Signup process",
  navFlow: NavFlow.FOCUS,
  title: "Sign up for Power Up",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeSignup",
  },
};
